import type { FeedbackFormStatus } from 'src/types';

import { m } from 'framer-motion';

import { Box, useTheme } from '@mui/material';

import { FEEDBACK } from 'src/utils/constants';

import { EFeedback } from 'src/types';

import { varFade } from 'src/components/animate';
import { Iconify } from 'src/components/iconify/iconify';

import CheckIcon from './components/CheckIcon';
import StyledTooltip from './components/StyledTooltip';
import ForwardedStyledButton from './components/StyledButton';

type Props = {
  onClick: (value: EFeedback) => void;
  status: FeedbackFormStatus;
};

function DislikeButton({ onClick, status }: Props) {
  const theme = useTheme();

  const disabled = status !== 'INITIAL';

  const renderedButton = (
    <ForwardedStyledButton
      onClick={() => onClick(EFeedback.DISLIKE)}
      disabled={disabled}
      className="dislike-button"
    >
      {status === 'SUBMITTED' ? (
        <Box sx={{ height: '16px' }}>
          <CheckIcon />
        </Box>
      ) : (
        <Box component={m.span} variants={varFade('in')} sx={{ height: '16px' }}>
          <Iconify
            icon="solar:dislike-outline"
            color={disabled ? theme.palette.error.main : theme.palette.text.secondary}
            width={16}
          />
        </Box>
      )}
    </ForwardedStyledButton>
  );

  if (disabled) return <>{renderedButton}</>;

  return <StyledTooltip title={FEEDBACK.TOOLTIP.DISLIKE}>{renderedButton}</StyledTooltip>;
}

export default DislikeButton;
